(function () {
  const cfg = window.sfwVat || {};
  const key = cfg.storageKey || 'sfwVatDisplay';

  function syncCheckboxesFromDocument(inputs) {
    const mode = document.documentElement.getAttribute('data-sfw-vat-display') || 'ex';
    const inc = mode === 'inc';
    inputs.forEach(function (input) {
      if (input.disabled) return;
      input.checked = inc;
      input.setAttribute('aria-checked', inc ? 'true' : 'false');
    });
  }

  function init() {
    const inputs = Array.from(document.querySelectorAll('[data-sfw-vat-toggle]'));
    if (!inputs.length) return;

    syncCheckboxesFromDocument(inputs);

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        const next = input.checked ? 'inc' : 'ex';
        try {
          localStorage.setItem(key, next);
        } catch (e) {
          /* ignore quota / private mode */
        }
        document.documentElement.setAttribute('data-sfw-vat-display', next);
        inputs.forEach(function (el) {
          if (el.disabled) return;
          el.checked = input.checked;
          el.setAttribute('aria-checked', input.checked ? 'true' : 'false');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
